import React, { ReactNode, useEffect, useId, useRef } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { XIcon } from "lucide-react";
import { spring } from "../../utils/motion";
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}
export function Modal({
  open,
  onClose,
  title,
  children,
  footer
}: ModalProps) {
  const reduce = useReducedMotion() ?? false;
  const titleId = useId();
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    panelRef.current?.focus();
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-1204" data-mp="2k681z8tyu528">
      {open && <div className="fixed inset-0 z-[70] flex items-end justify-center p-4 sm:items-center" data-id="element-1205" data-mp="2k32ge3kjplb9">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18
      }} onClick={onClose} className="absolute inset-0 bg-night/50" aria-hidden="true" data-id="element-1206" data-mp="2f8opoegtw2cx" />
          <motion.div ref={panelRef} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.97
      }} transition={spring.stable} className="relative w-full max-w-md rounded-panel border-3 border-line bg-surface p-6 shadow-brutal-lg outline-none" data-id="element-1207" data-mp="287vwf4ai0zq8">
            <div className="flex items-start justify-between gap-4" data-id="element-1208" data-mp="1gevirulu6c6w">
              <h2 id={titleId} className="text-xl font-bold tracking-[-0.01em] text-ink" data-id="element-1209" data-mp="1kg72xklxy57p">
                {title}
              </h2>
              <button type="button" onClick={onClose} aria-label="Close" className="focus-ring -mr-1 -mt-1 rounded-lg p-1.5 text-ink-2 hover:text-ink" data-id="element-1210" data-mp="3n472hsf8kkl0">
                <XIcon className="h-5 w-5" data-id="element-1211" data-mp="38dq0a6us1qn2" />
              </button>
            </div>
            <div className="mt-3 text-[15px] leading-relaxed text-ink-2" data-id="element-1212" data-mp="38bn22zjh0r79">{children}</div>
            {footer && <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end" data-id="element-1213" data-mp="9tzsjgpszc1x">{footer}</div>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}